import React, { useLayoutEffect, useState } from "react";
import type { ColumnsType, TableProps } from "antd/es/table";
import { Empty, Form } from "antd";

import { NOT_FOUND_TEXT } from "../../utils/constants";
import { StyledTable } from "./styles";

import EditableCell from "../EditableCellComponent";

export interface BasicUserInfo {
	id: string;
	userId?: string;
	fullName?: string;
	email?: string;
}

export interface CompanyInfo {
	companyName?: string;
	groupName?: string;
	position?: string;
	managerName?: string;
}

export interface AdditionalData {
	name?: string;
	year?: number;
	startDate?: string;
	endDate?: string;
	status?: string;
	action?: string;
	envelopeTypeLocalizableId?: string;
	envelopeType?: string;
}

export interface DataTypeProps extends BasicUserInfo, CompanyInfo, AdditionalData {
	roleId?: string;
	updateDate?: string;
	insertedDate?: string;
}

interface CustomTableProps {
	dataSource: DataTypeProps[];
	columns: ColumnsType<DataTypeProps>;
	loading?: boolean;
	maxWidth?: string;
	maxHeight?: number;
	rowSelection?: TableProps<DataTypeProps>['rowSelection'];
	rowKey?: string | ((record: DataTypeProps) => string);
	notFoundText?: string;
	rowClassName?: (record: DataTypeProps, index: number) => string;
}

const TableComponent: React.FC<CustomTableProps> = ({ dataSource, columns, loading, maxWidth, maxHeight, rowSelection, rowKey, notFoundText, rowClassName }) => {
	const tableStyle = maxWidth ? { maxWidth: maxWidth } : {};
	const [scrollProp, setScrollProp] = useState<{ x?: string; y?: string }>({});

	useLayoutEffect(() => {
		const fixedWidth = "885px";
		const width = maxWidth ? { x: maxWidth } : { x: fixedWidth };
		const height = maxHeight ? { y: `${maxHeight}px` } : { y: undefined };
		const newScrollProp = { ...width, ...height };
		setScrollProp(newScrollProp);
	}, [maxWidth, maxHeight]);

	const [form] = Form.useForm();

	return (
		<Form form={form} component={false}>
			{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
			{/* @ts-ignore */}

			<StyledTable
				components={{
					body: {
						cell: EditableCell
					}
				}}
				columns={columns}
				style={tableStyle}
				dataSource={dataSource}
				pagination={{ position: ["bottomCenter"] }}
				loading={loading}
				size="small"
				showSorterTooltip={false}
				scroll={scrollProp}
				rowKey={rowKey ? rowKey : (record) => record.id}
				locale={{
					emptyText: <Empty image={false} description={notFoundText ? notFoundText : NOT_FOUND_TEXT} />
				}}
				rowSelection={rowSelection}
				rowClassName={rowClassName}
			/>
			{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
		</Form>
	);
};

export default TableComponent;